const passengers = {
  passengers: 'Passageiros',
  passengerTypes: {
    default: 'Padrão',
    student: 'Estudante',
    employee: 'Funcionário',
    caregiver: 'Cuidador',
  },
  headerButtons: {
    create: {
      createBtn: 'Criar',
      employee: 'Funcionário',
      student: 'Aluno',
    },

    import: 'Importar',
  },

  toast: {
    error: {
      badResponse: '[Passenger] bad server response',
      create: {},
      edit: {},
    },
    success: {
      resetSuccess: 'O e-mail de Redefinição de Senha foi enviado com sucesso.',
      create: {
        default: '[Passenger] Criado',
      },
      edit: {
        default: '[Passenger] Atualizado',
      },
      delete: {
        default: '[Passenger] excluído com sucesso',
      },
    },
    alreadyExistToast: {
      messages: {
        phone: 'O telefone já está sendo utilizado por outro passageiro',
        email: 'O e-mail já está sendo utilizado por outro passageiro',
      },
    },
  },

  deleteModal: {
    header: 'Excluir Passageiros',
    body: 'Você está prestes a excluir {{num}} passageiros.',
  },

  create: {
    successToast: {
      message: 'Sucesso! Passageiro criado com sucesso',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar passageiro!',
    },
  },

  update: {
    successToast: {
      message: 'Sucesso! Atualizações de passageiros concluídas',
    },
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar Passageiro!',
    },
  },

  edit: {
    tabs: {
      information: 'Informações Gerais',
      notes: 'Observações',
      history: 'Histórico',
      bookingHistory: 'Histórico de reservas',
    },
    modalRemoveConfirm: {
      header: 'Aviso!',
      body: 'Você tem certeza que deseja excluir este passageiro?',
      modalRemoveConfirmBtnConfirm: 'Remover',
    },
    activeStatus: {
      statusActive: 'Ativo',
      statusDeactivate: 'Inativa',
    },
    suspend: {
      actionActivate: 'Reativar',
      actionDeactivate: 'Suspender',
      suspendModal: {
        popupTitleDeactivation: 'Suspender passageiro',
        popupTitleActive: 'Motivo de Suspensão',
        popupTitleUnsuspend: 'Motivo de Anular a Suspensão',
        popupSubTitleDeactivation: 'Selecione o motivo da suspensão',
        popupActionActive: 'Reativar Passageiro',
        popupActionDeactivate: 'Suspender passageiro',
      },
    },
  },

  table: {
    filters: {
      facility: 'Instalação',
      type: 'Tipo',
    },
    headers: {
      name: 'Nome',
      type: 'Tipo',
      email: 'E-mail',
      created: 'Data de criação',
      id: 'Identificação',
      profile: 'Perfil',
      supplier: 'Fornecedor',
      phone: 'Telefone',
      createdBy: 'Criado por',
      baseAddress: 'Endereço de casa',
      occupationAddress: 'Endereço do escritório',
    },
    passengersGettExtraHeaders: {
      home: 'Home',
      home2: 'Home2',
      work: 'Trabalho',
      site: 'Local',
    },
    empty: 'Vazio',
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },

  forms: {
    header: {
      createPassenger: {
        title: 'Criar',
      },

      updatePassenger: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      profile: {
        header: 'Perfil',
        fields: {
          profile: 'Perfil',
        },
      },
      supplier: {
        header: 'Fornecedor',
        fields: {
          label: 'Fornecedor Preferencial',
        },
      },
      attributes: {
        header: 'Atributos',
        fields: {
          label: 'Atributos',
        },
      },
      paymentTypes: {
        header: 'Tipos de pagamento',
        fields: {
          membership: 'Quadro de associados',
        },
        actions: {
          save: 'Editar',
        },
      },
      details: {
        header: 'Detalhes pessoais',
        fields: {
          firstName: 'Nome',
          lastName: 'Sobrenome',
          email: 'E-mail',
          phone: 'Telefone',
          ada: 'Ada',
          additionalPhone: 'Telefone Adicional',
          code: 'Código',
        },
      },
      address: {
        header: 'Endereço do passageiro',
        sharedValues: {
          manual: 'Endereço do manual',
        },
        fields: {
          homeAddress: {
            label: 'Endereço de casa',
          },
          homeAddress2: {
            label: 'Endereço Residencial 2',
          },
          officeAddress: {
            label: 'Endereço do escritório',
          },
          workAddress: {
            label: 'Endereço do trabalho',
          },
        },
      },
      actions: {
        header: 'Ações',
        buttons: {
          delete: 'Remover',
          resetPassword: 'Redefinir Senha',
        },
      },
      health: {
        header: 'Informações de Saúde',
        fields: {
          certificationDate: 'Data de Certificação',
          expirationDate: 'Data de Expiração',
          disabilityAidTools: 'Instrumentos de Apoio a Pessoas Deficientes',
        },
      },
      caregiverInfo: {
        header: 'Informações para Cuidadores',
        fields: {
          caregiverFirstName: 'Nome',
          caregiverLastName: 'Sobrenome',
          caregiverEmail: 'E-mail',
          caregiverPhone: 'Telefone',
        },
      },
      jobClusters: {
        header: 'Agrupamentos de Reservas',
        fields: {
          limitedMobility: 'Mobilidade Reduzida',
        },
        information: {
          limitedMobility:
            'O sistema irá ignorar a "Distância Máxima" e selecionará o ponto de embarque/desembarque mais próximo do endereço do passageiro',
        },
      },
    },
    jobHistory: {
      header: 'Histórico de reservas',
      popupInfo: {
        date: 'Horário de embarque solicitado: {{time}}',
        header: 'Informação de reserva',
        from: 'De:',
        to: 'Para:',
      },
    },

    validations: {
      firstName: 'Nome é obrigatório',
      lastName: 'Sobrenome é obrigatório',
      profiles: 'Perfis é obrigatório',
      email: {
        required: 'E-mail é obrigatório',
        email: 'Endereço de e-mail inválido',
      },
      unit: {
        required: 'O local é obrigatório',
      },
    },
  },

  statuses: {
    onATrip: 'Passageiros em uma viagem',
    completed: 'Passageiros concluiram viagens',
    created: 'Passageiros Criado (de {{hourFrom}})',
  },

  totalPassengers: 'Total de Passageiros',
};

export default passengers;
